import { z } from "zod";

export const assessorSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string().email(),
  role: z.coerce.number(),
  companies: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
});

export type Assessor = z.infer<typeof assessorSchema>;
